/**
 * Query key for publisher ID
 */
export const PUBLISHER_ID_QUERY_KEY = [
  'checking-account',
  'single-get-publisher-id'
] as [string, string]

export const contextActions: Record<string, RequestAdsURLParams[]> = {
  home: ['category_name', 'product_sku', 'brand_name', 'term'],
  category: ['product_sku', 'brand_name', 'term'],
  product_page: ['category_name', 'brand_name', 'term'],
  brand_page: ['product_sku', 'brand_name', 'term'],
  search: ['category_name', 'product_sku', 'brand_name']
}
